export const ProgressBarInf = () => {
  return (
    <div
      className="absolute bottom-0 left-0 h-[2px] w-full overflow-hidden"
      role="progressbar"
      aria-label="Loading"
    >
      <div
        className="h-full bg-primary animate-loading-bar"
        style={{
          background:
            "linear-gradient(90deg, transparent, hsl(var(--primary)), transparent)",
          animation: "loading-bar 1.5s ease-in-out infinite",
        }}
      />
    </div>
  );
};
